import { render, staticRenderFns } from "./FamilyDoctors.vue?vue&type=template&id=02ceaf88&"
import script from "./FamilyDoctors.vue?vue&type=script&lang=js&"
export * from "./FamilyDoctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports